import { render, staticRenderFns } from "./DeleteBusinessContact.vue?vue&type=template&id=71fde9cc&"
import script from "./DeleteBusinessContact.vue?vue&type=script&lang=js&"
export * from "./DeleteBusinessContact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports